
















import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapActions } from 'vuex';
import { ChoiceModule } from '@/store/modules/Choice';
import { Icon } from '@/store/models';
import { SurveyModule } from '@/store/modules/Survey';
import { AnswerModule } from '@/store/modules/Answer';
import { QuestionModule } from '@/store/modules/Question';

@Component({
	props: ['question'],
})
export default class StarRatingQuestion extends Vue {
	private choice: number = -1;
	private icons: Array<{lib: string}> = [];
	private iconsReady: boolean = false;

	/**
	 * get possible choices from choice module.
	 */
	private get choices() {
		return ChoiceModule.choices;
	}

	/**
	 * Get Answer from answer module.
	 */
	get answer() {
		return AnswerModule.answer;
	}

	/**
	 * Initialize data when component is created
	 */
	private created() {
		ChoiceModule.loadChoices(this.$props.question.id).then(() => {
			this.choices.forEach((choice, index) => {
				this.icons.push({lib: 'far'});
				if (index === (this.choices.length - 1)) {
					this.iconsReady = true;
				}
			});
		});
	}

	/**
	 * Clear stars until choosen answer
	 */
	private clearStars(): void {
		this.icons.forEach((icon: Icon, index: number) => {
			icon.lib = index > this.choice ? 'far' : 'fas';
		});
	}

	/**
	 * Fill stars to inedex
	 */
	private fillStars(index: number) {
		this.icons.forEach((icon: any, iconIndex: number) => {
			icon.lib = iconIndex <= index ? 'fas' : 'far';
		});
	}

	private setChoice(index: number) {
		this.choice = index;
		ChoiceModule.setChoice([index]);
	}
}
